export enum PaymentRails {
  MEX = 'MEX',
  USA = 'USA',
  DOLAR_APP = 'DOLAR_APP',
  EU = 'EU',
}
